module.exports = "\n    <h1>About</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.html
// module id = 414
// module chunks = 2